import React from 'react';
import { Spinner } from './Spinner';

export function SpinnerExample(): JSX.Element {
  return <Spinner color="var(--color-tint)" />;
}
